export const tabs = [
  { title: "Shrimp", value: "1" },
  { title: "Fish", value: "2" },
  { title: "Poultry", value: "3" },
  { title: "Ruminant", value: "4" },
  { title: "Snail", value: "5" },
];

export const poultrySlides = [
  {
     name: "BIOFENCE® STAGE-I",
     img: "/img/product_img/POULTRY/biofence-stage-i.png",
     imglogo: "/img/product_img/POULTRY/ProductLogos/BIOFENCE-STAGE-I.png"
  },
  {
     name: "DYNAGRO®",
     img: "/img/product_img/POULTRY/dynagro-mockup.png",
     imglogo: "/img/product_img/POULTRY/ProductLogos/DYNAGRO.png"
  },
  {
     name: "SILTRON®-P",
     img: "/img/product_img/POULTRY/siltron-p-mockup-copy.png",
     imglogo: "/img/product_img/POULTRY/ProductLogos/SILTRON-P.png"
  },
  {
     name: "INTRAGUARD™",
     img: "/img/product_img/POULTRY/intragurd-1l-copy.png",
     imglogo: "/img/product_img/POULTRY/ProductLogos/INTRAGAURD.png"
  },
];

export const shrimpSlides = [
  {
    name: "TOTAL®",
    img: "/img/product_img/SHRIMP/total_img.jpg",
    imglogo: "/img/product_img/SHRIMP/ProductLogos/TOTAL.png"
  },
  {
    name: "SOILEX®",
    img: "/img/product_img/SHRIMP/soilex-1kg-pouch-mockup-copy.png",
    imglogo: "/img/product_img/SHRIMP/ProductLogos/SOILEX.png"
  },
  {
    name: "TOXOFF®",
    img: "/img/product_img/SHRIMP/toxoff_img.jpg",
    imglogo: "/img/product_img/SHRIMP/ProductLogos/TOXOF.png"
  },
  {
    name: "ALBATREAT®",
    img: "/img/product_img/SHRIMP/albatreat-mockup-copy.png",
    imglogo: "/img/product_img/SHRIMP/ProductLogos/ALBATREAT.png"
  },
  {
    name: "SUMO®",
    img: "/img/product_img/SHRIMP/sumo-copy.png",
    imglogo : "/img/product_img/SHRIMP/ProductLogos/SUMO.png"
  }
];

export const fishSlides = [
  {
    name: "AMMORID®",
    imglogo: "/img/product_img/FISH/ProductLogos/AMMORID.png",  
    description:
      "Long-acting ammonia management solution for fish ponds.",
    img: "img/product_img/FISH/ammorid_img.png"
  },
  {
    name: "BIOMEND®",
    imglogo: "/img/product_img/FISH/ProductLogos/BIOMEND.png", 
    description:
      "Safe and effective fish pond treatment.",
    img: "/img/product_img/FISH/biomend-mockup-copy.png"
  },
  {
    name: "DIGIMAX®-F",
    imglogo: "/img/product_img/FISH/ProductLogos/DIGIMAX-F.png",
    description:
      "Synbiotic specially formulated for fish.",
    img: "/img/product_img/FISH/digimax-f-mockup-copy.png"
  },
];

export const snailSlides = [
  {
    name: "INTRON-AMMONIX®",
    imglogo: "/img/product_img/SNAIL/ProductLogos/ammonix-logo.png",
    description:
      "Eco-friendly ammonia management solution for snail farming.",
    img: "/img/product_img/SNAIL/ammonix_img_1.png"
  },
  {
    name: "INTRON BIOTRX®",
    imglogo: "/img/product_img/SNAIL/ProductLogos/biotrix-logo.png",
    description:
      "Complete bioremediation package for snail farming.",
    img: "/img/product_img/SNAIL/biotrx_img_1.png"
  },
  {
    name: "INTRON-TERREX®",
    imglogo: "/img/product_img/SNAIL/ProductLogos/terrex-logo.png",
    description:
      "Power-packed pond bottom management tool for snail farming.",
    img: "/img/product_img/SNAIL/terrex_img_1.png"
  },
];

export const ruminantSlides = [
  {
    name: "INTRAMIN-R®",
    imglogo: "/img/product_img/RUMINANT/ProductLogos/INTRAMIN-R.png",
    img: "/img/product_img/RUMINANT/intramin-r_mockup-copy.png"
  },
  {
    name: "LACTOMAX™-R",
    imglogo: "img/product_img/RUMINANT/ProductLogos/LACTOMAX-R.png",    
    description:
      "Next-gen synbiotic for cattle health and productivity.",
    img: "img/product_img/RUMINANT/lactomax-r-1kg-copy.png"
  },
  {
    name: "RUMIFERM®",
    imglogo: "/img/product_img/RUMINANT/ProductLogos/RUMIFERM.png",    
    description:
      "Silage/feed inoculant for enhancing nutrient value.",
    img: "/img/product_img/RUMINANT/rumiferm_mockup-copy.png"
  },
];
